window.fws = window.fws || {};
fws.Dropdown = (function() {
  
  function Dropdown($select) {
    var SELECTOR = '.dropdown-menu'
    var $container = $select.closest(SELECTOR)

    var closing = false

    this.$el = $select
    
    this.$el.select2({
      theme: 'matsuda',
      minimumResultsForSearch: -1,
      width: '100%',
    });
    this.$el.addClass('hide-element');

    this.$el.on('select2:opening', function(e) {
      $('.select2-results').removeClass('active')
    })

    // position and activate dropdown to fix item select click propagation bug
    this.$el.on('select2:open', _.bind(function(e) {
      var $results =  $('.select2-results')
      var $dropdown = $('.select2-results__options')
      var $selectedOption = $dropdown.find('[aria-selected="true"]')
      var selectedIndex = this.$el.select2('data')[0].element.index
      var menuOffset

      // TODO: value may need to change
      var optionHeight = 27;

      closing = false

      // prevents mousedown from acting on menu ass soon as it appears
      setTimeout(function() {
        if(!closing) {          
          $results.addClass('active')
        }
      }, 300)

      menuOffset = selectedIndex * optionHeight

      var hasNoLabel = $container.hasClass('dropdown-menu--no-label')
  
      // size the popup to the width of the dropdown control area with 
      // different handling depending on presence of a label to the left.
      var menuWidth = hasNoLabel ? 
        $container.width() + 16 :
        $container.find('.dropdown-menu__control').outerWidth() + 1

      $dropdown.css({
        marginTop: - 33 - menuOffset,
        width: menuWidth
      })
    } ,this))

    this.$el.on('select2:closing', function(e) {
      closing = true
      $('.select2-results').removeClass('active')
    })

    this.$el.on('select2:close', function(e) {
      $('.select2-results').removeClass('active')
    })

    this.$el.on('select2:select', _.bind(function(e) {
      this.$el.trigger({
        type: 'itemSelect.dropdown',
        itemId: e.params.data.id
      })
    }, this))

    return this
  }

  Dropdown.prototype = $.extend({}, Dropdown.prototype, {
    destroy: function() {
      this.$el.select2('destroy')

      this.$el.off('select2:open')
      this.$el.off('select2:closing')
      this.$el.off('select2:select')
    },

    select: function(value) {
      this.$el.val(value).trigger('change')
    }
  })

  return Dropdown;
})();

$(document).ready(function() {
  var FILTERED_GRID_CLASS = 'medium-up--one-third'
  var FILTERS = ['type', 'collection', 'material', 'shape', 'lens']
  
  

  
  var filterState;
  var hasInitialFilter;
  var resetMobile = false;

  var $el = $('.collection--list-wth-filters');
  var $results = $el.find('.results');
  var $resultCount = $el.find('.js-result-count');
  // if f/e, this is set post template rendering not here
  var $allResults = $results.find('.rm-product-grid__item')
  
  var hasInitialFilter = initFilterState()
  
  if(hasInitialFilter) {
    // don't let the initial layout show
    // will be removed when updateResults() is run
    $results.addClass('hidden');
  }

  initMobile();
  initDesktop();

  if(hasInitialFilter) {
    updateResults();

  } else {  
    updateResultCount($allResults.length);
  }

  function initDesktop() {

      // desktop shop logic
      var $resetBtn = $el.find('.result-info__reset')
      var desktopFilters = []
      
      var link = window.location.href
      if ( link.substr(link.length - 1) == "/" ) link = link.slice(0,-1)
      var coll = link.lastIndexOf('/') + 1
      if ( link.substring(coll) == "" ) coll = link.lastIndexOf('/') + 1
      var param = link.lastIndexOf('?')
      var collection = ""
      if (param != -1) collection = link.slice(coll, param)
      else collection = link.substring(coll)
      
      if (collection == "shop") collection = "sun"
      
      // init desktop filter dropdowns
      $el.find('.filters .filter').each(function() {    
        var $select = $(this).find('select')
        var filterId = $(this).data('filterId')
        var filterDropdown = new fws.Dropdown($select)

        // initial state from url params
        if (filterId == 'type') { 
          if(collection !== "sunglass" && collection !== "optical") {
            collection = "all";
          }
          filterDropdown.select(collection)
          //$(this).find('select').find('option[value="all"]').remove()
        }
        if(filterState[filterId]) {
          filterDropdown.select(filterState[filterId])
        }

        $select.on('itemSelect.dropdown', function(e) {
          var $select = $(this)
          var $filter = $select.closest('.filter')

          updateFilterState($filter.data('filterId'), e.itemId)
          updateResults()
        })

        desktopFilters.push(filterDropdown)
      })

      $resetBtn.on('click', resetDesktopRefineFilters)

      function resetDesktopRefineFilters() {
          var val = window.location.href;
          val = val.split('?')[0];
          window.location.href = val;
      }
      
    }

  function initFilterState() {
    // get initial filter state from url params
    var hasInitialFilter = false
    var u = new URLSearchParams(window.location.search)
    filterState = {}    

    FILTERS.forEach(function(id) {
      if(u.has(id)) {
        hasInitialFilter = true
        filterState[id] = u.get(id)
      }
    })

    return hasInitialFilter
  }
  function updateFilterState(key, value) {
    filterState[key] = value === 'all' ? null : value
    

    if (key == 'type' && !resetMobile) {
      var slug = (value) ? value : "all" 
      window.location.href = "/collections/" + slug
      return
    }
    updateFilterUrlParams()
  }
  function updateFilterUrlParams() {
    if(!window.history.pushState) {
      console.warn('no pushState');
      return
    }

    var u = new URLSearchParams(window.location.search)

    for(id in filterState) {
      if(filterState[id]) {
        u.set(id, filterState[id])

      } else {
        u.delete(id)
      }
    }

    var state
    if(u.toString().length) {
      state = '?' + u.toString()
    } else {
      var url = new URL(window.location)
      state = url.pathname
    }
    
    window.history.replaceState(null, null, state)
  }

  function updateResults(reset) {
    var value, $nestedGrid
    var $filteredResults = $allResults

    for (key in filterState) {
      value = filterState[key];
      if (value) {
        $filteredResults = $filteredResults.filter('[data-filter-' + key + '*=' + value + ']')
      }
    }

    $allResults.hide();

    $filteredResults.each(function (i) {
      var $result = $(this);
      $result.show();
    })

    // $results may have been hidden in case of initial filter set
    $results.removeClass('hidden')

    updateResultCount($filteredResults.length);

    if(initFilterState()) {
        $el.addClass('has-filter');
      } else {
        $el.removeClass('has-filter');
      }
  }

  function updateResultCount(count) {
    $resultCount.text(count)
      .parent().removeClass('hidden')
  }

  function initMobile() {
    // mobile shop logic
    var $refineBtn = $el.find('.refine-btn')
    var $refineOverlay = $el.find('.refine-overlay')
    var $refineClose = $refineOverlay.find('.refine-overlay__close-btn')
    var $refineReset = $refineOverlay.find('.refine-overlay__reset-btn')
    var $refineSubmit = $refineOverlay.find('.refine-overlay__submit-btn')
    var $filterTags = $el.find('.filter-tag')
    var mobileSelects = []
    
    var link = window.location.href
    if ( link.substr(link.length - 1) == "/" ) link = link.slice(0,-1)
    var coll = link.lastIndexOf('/') + 1
    if ( link.substring(coll) == "" ) coll = link.lastIndexOf('/') + 1
    var param = link.lastIndexOf('?')
    var collection = ""
    if (param != -1) collection = link.slice(coll, param)
    else collection = link.substring(coll)
    
    if (collection == "shop") collection = "sun"
    
    $refineBtn.on('click', showMobileRefineOverlay)
    $refineClose.on('click', hideMobileRefineOverlay)
    $refineReset.on('click', resetMobileRefineFilters)
    $refineSubmit.on('click', hideMobileRefineOverlay)

    // init mobile overlay filter dropdowns
    $refineOverlay.find('.filter').each(function() {
      var $select = $(this).find('select')
      var id = $(this).data('filterId')

      // initial value from url param
      if (id == 'type') {
        if(collection !== "sunglass" && collection !== "optical") {
            collection = "all";
        }
        $select.val(collection)
        //$(this).find('select').find('option[value="all"]').remove()
      }
      if(filterState[id]) {
        $select.val(filterState[id])
      }

      $select.on('change', function(e) {  
        $select = $(this)
        var $filter = $select.closest('.filter')
        updateFilterState($filter.data('filterId'), $select.val())
        updateFilterTags()
        updateResults()
      })

      mobileSelects.push($select)
    })

    // init mobile filter tags
    $filterTags.each(function() {
      var $tag = $(this)

      $tag.on('click', function() {
        $tag.hide()
        // reset the mobile overlay filter and apply change to results
        var key = $tag.data('filterId')      
        setMobileSelectFilter(key, 'all')
        updateFilterState(key, null)
        updateResults()
      })
    })

    // incase there are intial url param filters
    updateFilterTags()

    function setMobileSelectFilter(key, value) {
      $refineOverlay.find('.filter[data-filter-id='+ key +'] select').val(value)
    }

    function showMobileRefineOverlay() {
      $el.addClass('no-overflow')
      $('body').addClass('no-overflow')
      $refineOverlay.addClass('active')
    }

    function hideMobileRefineOverlay() {
      $el.removeClass('no-overflow')
      $('body').removeClass('no-overflow')
      $refineOverlay.removeClass('active')
    }

    function resetMobileRefineFilters() {
      // like calling setMobileSelectFilter(*, 'all') on for all 5
      for(var i=0; i<mobileSelects.length; i++) {
        if (i === 0) continue
        mobileSelects[i].val('all')
      }
      resetMobile = true

      resetFilterState()
      updateFilterTags()
      updateResults()
      resetMobile = false
    }

    function updateFilterTags() {
      $filterTags.hide()

      // read the state and show/hide tags
      var value
      for(var key in filterState) {
        value = filterState[key]

        if(value) {
          $filterTags.filter('[data-filter-id='+ key +']')
            .text(value)
            .show()
        }
      }
    }
  }
})